import { useMemo } from "react";
import { modalActions } from "@context/modals";
import { MODAL_TYPES } from "types/modals";
import { toFarsiNumber } from "@utils/digits";
import { CopounHeaderProps, COUPON_STATUS } from "./types";

export const useCopounHeader = ({
  expireDateFormatted,
  productName,
  percentAfterCoupon,
  price,
  courseCouponUrl,
  productId,
  expiryStatus,
}: CopounHeaderProps) => {
  const days = useMemo(() => {
    const expireTs = new Date(expireDateFormatted || "").getTime();
    if (!Number.isFinite(expireTs)) return 0;

    const diffMs = Math.max(0, expireTs - Date.now());
    return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  }, [expireDateFormatted]);

  const message = useMemo(() => {
    const expireTs = new Date(
      (expireDateFormatted || "").replace("Z", "")
    ).getTime();

    const diffMs = Math.max(0, expireTs - Date.now());
    const totalHours = Math.ceil(diffMs / (1000 * 60 * 60));

    const DAY_MS = 1000 * 60 * 60 * 24;
    const days = diffMs / DAY_MS;

    const totalDays = days <= 0 ? 0 : days < 2 ? 1 : Math.floor(days);

    const isHourMode = totalHours <= 24;
    const value = isHourMode
      ? totalHours === 1
        ? "یک"
        : totalHours
      : totalDays;

    const unit = isHourMode ? "ساعت" : "روز";
    const prefix = totalDays > 10 ? "" : isHourMode ? "کمتر از" : "فقط";

    return `${prefix} ${toFarsiNumber(
      value
    )} ${unit} تا پایان مهلت دسترسی به ${productName} باقی مانده است.`;
  }, [expireDateFormatted, productName]);

  const status: COUPON_STATUS =
    days >= 10 ? COUPON_STATUS.MORETHAN10: days > 1 ? COUPON_STATUS.LESSTHAN10 : COUPON_STATUS.LESSTHAN24;

  const handleCourseCoupon = () => {
    if (!expiryStatus) return;

    modalActions.addModal(MODAL_TYPES.COUPON_PRODUCT, {
      config: { hideCloseIcon: true },
      data: {
        discount: percentAfterCoupon || 0,
        expireDay: expireDateFormatted || "",
        price: price || 0,
        product: productName || "",
        productUrl: courseCouponUrl,
        id: productId,
        expiryStatus,
      },
    });
  };

  return {
    days,
    message,
    status,
    handleCourseCoupon,
  };
};
